import React, { useEffect, useRef, useState } from 'react';

export default (WrapperComponent) => {
  return (props) => {
    if (typeof window === 'undefined') {
      return null;
    }
    let lastScrollTop = 0;
    let maxWidth = props.MaxWidth ? props.MaxWidth : 768;

    const [isMobile, setIsMobile] = useState(window.innerWidth < maxWidth);
    const [isHidden, setIsHidden] = useState(true);

    let header = useRef(null);

    useEffect(() => {
      header.current = document.querySelector('.c-header');
    }, []);

    const setHeaderIsHidden = () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (header.current) {
        if (scrollTop > lastScrollTop) {
          header.current.classList.add('c-header--hidden');
          header.current.classList.remove('c-header--visible');
          setIsHidden(false);
        } else if (scrollTop < lastScrollTop) {
          header.current.classList.remove('c-header--hidden');
          header.current.classList.add('c-header--visible');
          setIsHidden(true);
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      }
    };

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < maxWidth);
      };

      window.addEventListener('resize', handleResize);

      return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
      if (isMobile) {
        window.addEventListener('scroll', setHeaderIsHidden);
        if (header.current) {
          header.current.classList.add('c-header--visible');
        }
      } else {
        window.removeEventListener('scroll', setHeaderIsHidden);
        if (header.current) {
          header.current.classList.remove('hidden', 'c-header--visible');
        }
      }

      return () => window.removeEventListener('scroll', setHeaderIsHidden);
    }, [isMobile]);

    return (
      <WrapperComponent IsHidden={isHidden} IsMobile={isMobile} {...props} />
    );
  };
};

